<script lang="ts">
export let name;
</script>

<div class="gameTitle">
    {name}
</div>

<style>
    .gameTitle {
        width: 100%;
        margin: 0 auto;
        color: #a59882;
        text-align: center;
        font-weight: bold;
        font-size: 40px;
        text-shadow: 0 0 4px #fff;
    }
</style>